(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Text-image"] && !Shopify.designMode) return;
  try {
    
/* No JS needed. Add here if you later attach observers or tracking. */

  } catch(e) { console.error(e); }
})();
})();
